@let recordName = recordNameSg();
@let isRecordLoading =
  recordsEc.plugins.currentEntityPlugin.feature.selectors
    .isLoading()
    .asSignal();
@let presentRecordHistoryLog = presentRecordHistoryLogSg();
@let isSignedOff = isSignedOffSg();
@let isSigningOff =
  surveyStatusPlugin.selectors.isSubmitting(OperationEnum.SignOff).asSignal();
@let isUnlocking =
  surveyStatusPlugin.selectors.isSubmitting(OperationEnum.Unlock).asSignal();
@let isVacant = isVacantSg();
@let canUnlockRoom = canUnlockSg();

<atn-ds-page [scrollable]="true">
  <div class="atn-record-details">
    <!-- TODO: Provide the `loading` property to show a loader inside the header component when necessary -->
    <atn-ds-page-header
      [breadcrumbs]="breadcrumbsSg()"
      pageHeader
    >
      <div
        name
        class="atn-record-details__title"
      >
        <h4>{{ recordName ? `Room ${recordName}` : recordName }}</h4>
        <atn-ds-tag [text]="surveyStatusSg()" />
        @if (isVacant) {
          <atn-ds-tag
            text="Vacant"
            [style]="TagStyleEnum.Warning"
          />
        }
      </div>
      <div
        actions
        class="atn-record-details__header-actions"
      >
        <button
          #origin
          class="atn-record-details__header-action-button"
          [disabled]="isRecordLoading"
          (click)="presentRecordHistoryLogSg.set(!presentRecordHistoryLog)"
        >
          <i class="atn-icon atn-history atn-blue"></i>
        </button>
        @if (isSignedOff) {
          @if (canUnlockRoom) {
            <button
              class="atn-record-details__header-action-button"
              [disabled]="isUnlocking"
              (click)="initiateClickHandler(OperationEnum.Unlock)"
            >
              <i class="atn-icon atn-unlock atn-blue"></i>
            </button>
          }
        } @else {
          <button
            class="atn-record-details__header-action-button"
            [disabled]="isSigningOff"
            (click)="initiateClickHandler(OperationEnum.SignOff)"
          >
            <i class="atn-icon atn-approve atn-blue"></i>
          </button>
        }
      </div>
    </atn-ds-page-header>

    <div class="atn-record-details__content">
      <atn-space-lite-record-general [readonly]="isSignedOff" />

      <atn-space-organization-assignments [readonly]="isSignedOff" />
    </div>
  </div>
</atn-ds-page>

@if (presentRecordHistoryLog) {
  <atn-ds-attached-overlay
    [hasBackdrop]="true"
    [origin]="origin"
    (backdropClick)="presentRecordHistoryLogSg.set(false)"
  >
    <atn-record-history-log (close)="presentRecordHistoryLogSg.set(false)" />
  </atn-ds-attached-overlay>
}

@if (
  surveyStatusPlugin.selectors.isConfirming(OperationEnum.SignOff).asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Sign Off Room"
    description="Are you sure want to Sign Off this room?"
    confirmButtonText="Sign Off"
    [loading]="isSigningOff"
    [error]="
      surveyStatusPlugin.selectors
        .getErrorMessage(OperationEnum.SignOff)
        .asSignal()
    "
    (cancel)="cancelClickHandler(OperationEnum.SignOff)"
    (confirm)="confirmClickHandler(OperationEnum.SignOff)"
  />
}

@if (
  surveyStatusPlugin.selectors.isConfirming(OperationEnum.Unlock).asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Unlock Room"
    description="Are you sure?"
    confirmButtonText="Unlock"
    [loading]="isUnlocking"
    [error]="
      surveyStatusPlugin.selectors
        .getErrorMessage(OperationEnum.Unlock)
        .asSignal()
    "
    (cancel)="cancelClickHandler(OperationEnum.Unlock)"
    (confirm)="confirmClickHandler(OperationEnum.Unlock)"
  />
}
